var map = {
	"./bank-transfer.svg": 818,
	"./betnearn-ico.svg": 819,
	"./birthday-bonus-ico.svg": 820,
	"./birthday.svg": 821,
	"./bonus-code-ico.svg": 822,
	"./bonus-ico.svg": 823,
	"./bonus-received-ico.svg": 824,
	"./bonus.svg": 825,
	"./business-account-upgrade-ico.svg": 826,
	"./check-in-daily-ico.svg": 827,
	"./checked.svg": 828,
	"./cloud-pointer.svg": 829,
	"./coin.svg": 830,
	"./crypto.svg": 831,
	"./daily-bonus-ico.svg": 832,
	"./daily-limit.svg": 833,
	"./deposit-delay-bonus-ico.svg": 834,
	"./e-wallet.svg": 835,
	"./earn-x33-coin-ico.svg": 836,
	"./email.svg": 837,
	"./facebook.svg": 838,
	"./feedback.svg": 839,
	"./first-bet-ico.svg": 840,
	"./games-rebate-ico.svg": 841,
	"./info.svg": 842,
	"./instagram.svg": 843,
	"./live-casino-rebate-ico.svg": 844,
	"./lucky-spin-ico.svg": 845,
	"./messenger.svg": 846,
	"./mobile-app-deposit-ico.svg": 847,
	"./monthly-cash.svg": 848,
	"./msg-activity.svg": 849,
	"./msg-ann.svg": 850,
	"./msg-notice.svg": 851,
	"./new-icon.svg": 852,
	"./people-ico.svg": 853,
	"./quick-pay.svg": 854,
	"./rescue-bonus-ico.svg": 855,
	"./rescue-lc-ico.svg": 856,
	"./rescue-slots-ico.svg": 857,
	"./return.svg": 858,
	"./sc-bc-active-ico.svg": 859,
	"./sc-bc-ico.svg": 860,
	"./sc-bi-active-ico.svg": 861,
	"./sc-bi-ico.svg": 862,
	"./sc-mail-active-ico.svg": 863,
	"./sc-mail-ico.svg": 864,
	"./sc-mp-active-ico.svg": 865,
	"./sc-mp-ico.svg": 866,
	"./sc-pin-active-ico.svg": 867,
	"./sc-pin-ico.svg": 868,
	"./slots-rebate-ico.svg": 869,
	"./sms.svg": 870,
	"./sports-rebate-ico.svg": 871,
	"./telegram.svg": 872,
	"./twitter.svg": 873,
	"./vip-up-level-ico.svg": 874,
	"./vip-weekly-bonus.svg": 875,
	"./wallet-balance-interest-ico.svg": 876,
	"./wallet-ico.svg": 877,
	"./weekly-tournament-ico.svg": 878,
	"./welcome-bonus-188-ico.svg": 879,
	"./welcome-bonus-ico.svg": 880,
	"./whatsapp-original.svg": 881,
	"./whatsapp.svg": 882,
	"./withdrawal-delay-bonus-ico.svg": 883,
	"./withdrawal.svg": 884,
	"./x33-coin.svg": 885
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1905;